const getters={
    
    img_url: state =>state.detail_img
}

export default getters